import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AddIcon from "@mui/icons-material/Add";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import ApiIcon from "@mui/icons-material/Api";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BarChartIcon from "@mui/icons-material/BarChart";
import BookIcon from "@mui/icons-material/Book";
import BugReportIcon from "@mui/icons-material/BugReport";
import BusinessIcon from "@mui/icons-material/Business";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CancelIcon from "@mui/icons-material/Cancel";
import CategoryIcon from "@mui/icons-material/Category";
import ChatIcon from "@mui/icons-material/Chat";
import CheckIcon from "@mui/icons-material/Check";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChecklistIcon from "@mui/icons-material/Checklist";
import CloseIcon from "@mui/icons-material/Close";
import CloudIcon from "@mui/icons-material/Cloud";
import CodeIcon from "@mui/icons-material/Code";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import ContactsIcon from "@mui/icons-material/Contacts";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DataObjectIcon from "@mui/icons-material/DataObject";
import DeleteIcon from "@mui/icons-material/Delete";
import DescriptionIcon from "@mui/icons-material/Description";
import DevicesIcon from "@mui/icons-material/Devices";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import EmailIcon from "@mui/icons-material/Email";
import EventIcon from "@mui/icons-material/Event";
import FolderIcon from "@mui/icons-material/Folder";
import GroupIcon from "@mui/icons-material/Group";
import HelpIcon from "@mui/icons-material/Help";
import HistoryIcon from "@mui/icons-material/History";
import HomeIcon from "@mui/icons-material/Home";
import HouseIcon from "@mui/icons-material/House";
import InfoIcon from "@mui/icons-material/Info";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import InsightsIcon from "@mui/icons-material/Insights";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import InventoryIcon from "@mui/icons-material/Inventory";
import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import ListIcon from "@mui/icons-material/List";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import LockIcon from "@mui/icons-material/Lock";
import MailIcon from "@mui/icons-material/Mail";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MapIcon from "@mui/icons-material/Map";
import MemoryIcon from "@mui/icons-material/Memory";
import MenuIcon from "@mui/icons-material/Menu";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import NoteIcon from "@mui/icons-material/Note";
import NotificationsIcon from "@mui/icons-material/Notifications";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PaymentIcon from "@mui/icons-material/Payment";
import PeopleIcon from "@mui/icons-material/People";
import PercentIcon from "@mui/icons-material/Percent";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReportIcon from "@mui/icons-material/Report";
import SaveIcon from "@mui/icons-material/Save";
import SchemaIcon from "@mui/icons-material/Schema";
import SearchIcon from "@mui/icons-material/Search";
import SecurityIcon from "@mui/icons-material/Security";
import SettingsIcon from "@mui/icons-material/Settings";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SpeedIcon from "@mui/icons-material/Speed";
import StorageIcon from "@mui/icons-material/Storage";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import TableChartIcon from "@mui/icons-material/TableChart";
import TaskIcon from "@mui/icons-material/Task";
import TimelineIcon from "@mui/icons-material/Timeline";
import TuneIcon from "@mui/icons-material/Tune";
import ViewListIcon from "@mui/icons-material/ViewList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WarningIcon from "@mui/icons-material/Warning";
import WorkIcon from "@mui/icons-material/Work";
import React from "react";

type IconComponentProps = {
  iconName?: string;
  size?: "small" | "medium" | "large" | "inherit";
  fontSize?: number | string;
};

const getIcon = (iconName: string, fontSize?: "small" | "medium" | "large" | "inherit", customFontSize?: number | string): React.ReactElement => {
  const style = customFontSize ? { fontSize: customFontSize } : undefined;
  const props = { fontSize, style };

  const iconMap: Record<string, React.ReactElement> = {
    AccountCircle: <AccountCircleIcon {...props} />,
    Add: <AddIcon {...props} />,
    AlternateEmail: <AlternateEmailIcon {...props} />,
    Api: <ApiIcon {...props} />,
    ArrowForward: <ArrowForwardIcon {...props} />,
    ArrowOutward: <ArrowOutwardIcon {...props} />,
    Assessment: <AssessmentIcon {...props} />,
    BarChart: <BarChartIcon {...props} />,
    Book: <BookIcon {...props} />,
    BugReport: <BugReportIcon {...props} />,
    Business: <BusinessIcon {...props} />,
    CalendarMonth: <CalendarMonthIcon {...props} />,
    CalendarToday: <CalendarTodayIcon {...props} />,
    Category: <CategoryIcon {...props} />,
    Cancel: <CancelIcon {...props} />,
    Chat: <ChatIcon {...props} />,
    CheckCircle: <CheckCircleIcon {...props} />,
    Check: <CheckIcon {...props} />,
    Checklist: <ChecklistIcon {...props} />,
    Cloud: <CloudIcon {...props} />,
    Close: <CloseIcon {...props} />,
    Code: <CodeIcon {...props} />,
    ContactEmail: <ContactMailIcon {...props} />,
    ContactEmergency: <ContactEmergencyIcon {...props} />,
    ContactMail: <ContactMailIcon {...props} />,
    Contact: <ContactPhoneIcon {...props} />,
    Contacts: <ContactsIcon {...props} />,
    Dashboard: <DashboardIcon {...props} />,
    DataObject: <DataObjectIcon {...props} />,
    Description: <DescriptionIcon {...props} />,
    Devices: <DevicesIcon {...props} />,
    Download: <DownloadIcon {...props} />,
    Delete: <DeleteIcon {...props} />,
    Edit: <EditIcon {...props} />,
    Email: <EmailIcon {...props} />,
    Event: <EventIcon {...props} />,
    Folder: <FolderIcon {...props} />,
    Group: <GroupIcon {...props} />,
    Help: <HelpIcon {...props} />,
    History: <HistoryIcon {...props} />,
    Home: <HomeIcon {...props} />,
    House: <HouseIcon {...props} />,
    Info: <InfoIcon {...props} />,
    InsertDriveFile: <InsertDriveFileIcon {...props} />,
    Insights: <InsightsIcon {...props} />,
    IntegrationInstructions: <IntegrationInstructionsIcon {...props} />,
    Inventory: <InventoryIcon {...props} />,
    List: <ListIcon {...props} />,
    LocalAtm: <LocalAtmIcon {...props} />,
    Lock: <LockIcon {...props} />,
    Link: <LinkIcon {...props} />,
    LinkOff: <LinkOffIcon {...props} />,
    Mail: <MailIcon {...props} />,
    MailOutline: <MailOutlineIcon {...props} />,
    Map: <MapIcon {...props} />,
    Memory: <MemoryIcon {...props} />,
    Menu: <MenuIcon {...props} />,
    MonetizationOn: <MonetizationOnIcon {...props} />,
    Notifications: <NotificationsIcon {...props} />,
    Note: <NoteIcon {...props} />,
    OpenInNew: <OpenInNewIcon {...props} />,
    Payment: <PaymentIcon {...props} />,
    People: <PeopleIcon {...props} />,
    Percent: <PercentIcon {...props} />,
    Person: <PersonIcon {...props} />,
    Phone: <PhoneIcon {...props} />,
    PlayArrow: <PlayArrowIcon {...props} />,
    Report: <ReportIcon {...props} />,
    Receipt: <ReceiptIcon {...props} />,
    Schema: <SchemaIcon {...props} />,
    Search: <SearchIcon {...props} />,
    Save: <SaveIcon {...props} />,
    Security: <SecurityIcon {...props} />,
    Settings: <SettingsIcon {...props} />,
    ShoppingCart: <ShoppingCartIcon {...props} />,
    Speed: <SpeedIcon {...props} />,
    Storage: <StorageIcon {...props} />,
    SupervisorAccount: <SupervisorAccountIcon {...props} />,
    TableChart: <TableChartIcon {...props} />,
    Task: <TaskIcon {...props} />,
    Timeline: <TimelineIcon {...props} />,
    Tune: <TuneIcon {...props} />,
    ViewList: <ViewListIcon {...props} />,
    Visibility: <VisibilityIcon {...props} />,
    Warning: <WarningIcon {...props} />,
    Work: <WorkIcon {...props} />,
  };

  return iconMap[iconName] || <MenuIcon {...props} />;
};

const IconComponent: React.FC<IconComponentProps> = ({ iconName, size, fontSize }) => {
  if (!iconName) {
    return getIcon("Menu", size, fontSize);
  }

  return getIcon(iconName, size, fontSize);
};

export default IconComponent;
